//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'



//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selectore = (state) => state.howToVideos;
//  -- Examples array selector --------



export const useHowToVideos = () =>{
    const selectedData = useSelector(selectore, shallowEqual)
    return selectedData;
}